var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "d-flex flex-row" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("FormPageAccount", {
                attrs: {
                  data: _vm.account,
                  profiles: _vm.profiles,
                  sharedAccess: _vm.sharedAccess,
                  reservations: _vm.reservations,
                  ticketReservations: _vm.ticketReservations,
                  loading: _vm.isFormLoading,
                  disabled: _vm.isMutationLoading,
                  isNew: !_vm.id,
                },
                on: {
                  submit: _vm.formAccountSubmit,
                  "delete-account": _vm.deleteAccount,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmUserRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }